import React, { Component } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import ReactCalendar from 'react-calendar/dist/entry.nostyle'
import { scroller } from 'react-scroll'
import { withStyles, Paper } from '@material-ui/core'
import { getDaysInMonth } from 'date-fns'

import {
  getShowedMonth,
  getShowedYear,
  getDays,
  isAvailabilitiesLoading
} from '../../store/availability/selectors'
import {
  fetchAvailabilitiesForMonth,
  availabilitiesStartLoading
} from '../../store/availability/actions'
import { bookingSelectDay } from '../../store/booking/actions'
import { getSelectedDay } from '../../store/booking/selectors'
import { Loading } from '../atoms/Loading'
import {
  getGarageDateFirstDay,
  getGarageDateLastDay
} from '../../store/garage/selectors'

import './Calendar.css'

const styles = theme => ({
  root: {
    position: 'relative',
    overflow: 'hidden'
  },
  calendar: {
    border: 'none',
    width: '100%'
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    top: 44,
    bottom: 0,
    backgroundOrigin: 'content-box',
    background: 'white'
  }
})

export class CalendarBase extends Component {
  constructor(props) {
    super(props)

    this.debouncedLoadAvailabilities = debounce(props.loadAvailabilities, 500)
  }

  componentDidMount() {
    this.loadMonth(new Date(), false)
  }

  loadMonth = (day, shouldDebounce) => {
    const { dateLimitStart, dateLimitEnd, startLoading } = this.props

    let start = day
    let end = new Date(day.getFullYear(), day.getMonth(), getDaysInMonth(day))

    if (start > dateLimitEnd || end < dateLimitStart) {
      // no loading
      return
    }

    if (!this.isDayInRange(start)) {
      start = dateLimitStart
    }

    if (!this.isDayInRange(end)) {
      end = dateLimitEnd
    }

    startLoading()
    if (shouldDebounce) {
      this.debouncedLoadAvailabilities(start, end)
    } else {
      this.props.loadAvailabilities(start, end)
    }
  }

  handleDayClick = value => {
    scroller.scrollTo('hourPicker', {
      duration: 800,
      delay: 200,
      smooth: true
    })
    this.props.onChange(value)
  }

  isDayInRange = date => {
    const { dateLimitStart, dateLimitEnd } = this.props

    return date >= dateLimitStart && date <= dateLimitEnd
  }

  computeClassForDay = ({ date }) => {
    const { days } = this.props
    const day = date.getDate()

    if (!this.isDayInRange(date)) return 'day-status-out-limit'

    const className =
      'day-status-' +
      (days.find(item => item.day === day) || { state: 'busy' }).state

    return className
  }

  render() {
    const { classes, showedMonth, showedYear, selectedDay } = this.props

    return (
      <Paper className={classes.root}>
        <ReactCalendar
          className={classes.calendar}
          activeStartDate={new Date(showedYear, showedMonth, 1)}
          value={selectedDay}
          minDetail="month"
          locale="it-IT"
          showNeighboringMonth={false}
          onActiveDateChange={({ activeStartDate }) => {
            this.loadMonth(activeStartDate, true)
          }}
          onClickDay={this.handleDayClick}
          tileClassName={this.computeClassForDay}
        />

        {this.props.isLoading && (
          <div className={classes.loadingContainer}>
            <Loading />
          </div>
        )}
      </Paper>
    )
  }
}

export const Calendar = withStyles(styles)(CalendarBase)

const mapStateToProps = state => ({
  showedMonth: getShowedMonth(state),
  showedYear: getShowedYear(state),
  selectedDay: getSelectedDay(state),
  days: getDays(state),
  isLoading: isAvailabilitiesLoading(state),
  dateLimitStart: getGarageDateFirstDay(state),
  dateLimitEnd: getGarageDateLastDay(state)
})

const mapDispatchToProps = dispatch => ({
  startLoading: () => dispatch(availabilitiesStartLoading()),
  loadAvailabilities: (year, month) =>
    dispatch(fetchAvailabilitiesForMonth(year, month)),
  onChange: day => dispatch(bookingSelectDay(day))
})

export const LinkedCalendar = connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar)
